module.exports = __webpack_public_path__ + "static/media/fiori2.efe2c699.png";